// Délai avant de rouvrir un WebSocket coupé (bugs-clients-prod:B0_69).
//
// Une coupure du serveur ferme toutes les connexions au même instant : avec un délai fixe,
// elles reviennent toutes dans la même seconde (mesuré : 16 reconnexions en 30 ms sur DEV,
// ~2 570/s attendues en prod contre 1 500/s de capacité TLS au répartiteur). D'où :
// - un aléa sur toute la fenêtre (5 s + 0 à 10 s), y compris au plafond — un plafond posé
//   après l'aléa ramènerait les clients en échec prolongé sur la même valeur ;
// - un doublement à chaque échec consécutif, plafonné à ×8 (fenêtre 40 – 120 s) ;
// - aucune limite du nombre d'essais : abandonner arrêterait le temps réel jusqu'au
//   rechargement de la page.
//
// Module pur, sans import : il est aussi importé (en relatif) par le package integrations,
// dont les tests passent par le jest racine qui ne résout pas les alias.

export const RECONNECT_BASE_MS = 5000;
export const RECONNECT_SPREAD_MS = 10000;
export const RECONNECT_MAX_DOUBLINGS = 3;

/** `attempt` = nombre d'échecs consécutifs depuis la dernière ouverture réussie (0 au premier essai). */
export const reconnectDelay = (attempt: number, random: () => number = Math.random) =>
  (RECONNECT_BASE_MS + random() * RECONNECT_SPREAD_MS) *
  2 ** Math.min(Math.max(attempt, 0), RECONNECT_MAX_DOUBLINGS);
